import { Injectable, inject } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { jwtDecode } from 'jwt-decode';
import { ConfigService } from '../../core/services/config.service';
import { JwtToken } from '../models/auth.models';
@Injectable({ providedIn: 'root' })
export class AuthGuard {
    constructor(
        private router: Router,
        public configService: ConfigService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let currentstate = state.url;
        let token = localStorage.getItem("Token");
        if (currentstate == '/') {
            this.router.navigate(['/dashboard']);
            return false;
        } else if(token == null){
            // this.configService.showAlert("Token Undefined", "", "error");
            this.router.navigate(['/login']);
            return false;
        }else{
            try {
                let tokenDecode: JwtToken = jwtDecode(token);
                !tokenDecode.url_img_avatar && (tokenDecode.url_img_avatar = this.configService.url.DefaultAvatar);
                this.configService.token = tokenDecode;
                console.log(tokenDecode);
                const currentTime = Date.now() / 1000;
                if(tokenDecode.exp > currentTime) return true;
                else{
                    localStorage.removeItem("Token");
                    currentTime - tokenDecode.exp < 3600 && this.configService.showAlert("Token Expired", "", "error");
                    this.router.navigate(['/login']);
                    return false;
                }
            } catch (Error) {
                localStorage.removeItem("Token");
                this.configService.showAlert("Token Invalid", "", "error");
                this.router.navigate(['/login']);
                return false;
            }
        }
    }
}
